import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ListaBreadcrumbs from './components/Breadcrumbs/ListaBreadcrumbs.vue';

library.add(fas, far);

export default (app) => {
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.component('VueDatePicker', VueDatePicker);
  app.component('ListaBreadcrumbs', ListaBreadcrumbs);
};
